import { View } from "react-native";
import React, { useEffect, useState } from "react";
import MainContainer from "components/MainContainer";
import { Text } from "@ui-kitten/components";
import StepOne from "./StepOne";
import { useAppSelector } from "hooks/useAppSelector";
import HiddenView from "components/HiddenView";
import StepTwo from "./StepTwo";
import {
  GroupReservationScreenProps,
  RootStackParamList,
} from "navigation/types";
import StepThree from "./StepThree";
import { RouteProp, useRoute } from "@react-navigation/native";
import EventBanner from "components/EventBanner";
import { useFetchEventByCodeQuery } from "queries/event.queries";
import i18n from "plugins/localization";
import { toDashboard } from "utils/navigationUtils";
import { formatEventDate } from "utils/eventUtils";

const GroupReservation = ({ navigation }: GroupReservationScreenProps) => {
  const storedUserId = useAppSelector((state) => state.auth.id);
  const [step, setStep] = useState(0);
  const route = useRoute<RouteProp<RootStackParamList, "GroupReservation">>();
  const { eventCode } = route.params;
  const { data: event } = useFetchEventByCodeQuery(eventCode);

  useEffect(() => {
    if (storedUserId === undefined) {
      setStep(1);
    } else {
      setStep(3);
    }
  }, [storedUserId]);

  if (!event) {
    return null;
  }
  return (
    <MainContainer
      showHeader={step === 3}
      title={i18n.t("screens.GroupReservation.title")}
      goBackAction={toDashboard}
      grayBackground
    >
      <View style={{ padding: 15 }}>
        {event !== null && (
          <View>
            <EventBanner event={event} />
            <Text category="h6" style={{ marginTop: 15 }}>
              {i18n.t("screens.GroupReservation.youHaveBeenInvited", {
                eventName: event.name,
              })}
            </Text>
            <Text category="c2" style={{ marginTop: 5 }}>
              {i18n.t("screens.GroupReservation.localDate", {
                date: formatEventDate(event),
              })}
            </Text>
          </View>
        )}

        <HiddenView shouldHide={storedUserId !== undefined}>
          <HiddenView shouldHide={step !== 1}>
            <StepOne setStep={setStep}></StepOne>
          </HiddenView>
          <HiddenView shouldHide={step !== 2}>
            <StepTwo></StepTwo>
          </HiddenView>
        </HiddenView>

        {step === 3 && event !== null && <StepThree event={event}></StepThree>}
      </View>
    </MainContainer>
  );
};

export default GroupReservation;
